var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6061 12.5591C24.6061 19.2197 19.2095 24.6187 12.5531 24.6187C5.89658 24.6187 0.5 19.2197 0.5 12.5591C0.5 5.89853 5.89658 0.499512 12.5531 0.499512C19.2095 0.499512 24.6061 5.89853 24.6061 12.5591Z",
    fill: "#14142B",
    fillOpacity: 0.44,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7734 15.904L10.7723 15.9047C10.3933 16.1254 9.91504 15.8542 9.91504 15.4065V9.70974C9.91504 9.26761 10.3925 8.99258 10.7737 9.21239C10.7738 9.21244 10.7739 9.21248 10.7739 9.21253L15.6879 12.0581C15.688 12.0582 15.6882 12.0583 15.6884 12.0584C16.0737 12.2833 16.07 12.8376 15.6895 13.0572L15.689 13.0575L10.7734 15.904Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.94125f3a1ea5996ebc5ee88ae8fcb7c8.svg";
export { ForwardRef as ReactComponent };